import React, { useContext, useState } from "react";
import "./sidebar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faUser,
  faCog,
  faSignOutAlt,
  faBullhorn,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import "../premiumFeature/premiumFeature.css"; // Adjust the path correctly
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const Sidebar = () => {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const userRole = localStorage.getItem("role");

  const handleLogOut = () => {
    logout();
    setLogoutDialogOpen(false);
    navigate("/");
  };

  const handleClickProfile = () => {
    navigate("/profile");
  };

  const handleClickPremiumFeature = () => {
    navigate("/premiumFeature"); 
  };

  return (
    <div className="sidebar">
      <div className="sidebar-top">
        {(userRole === "crew" || userRole === "actor") && (
          <button
            className="sidebar-button"
            onClick={handleClickPremiumFeature}
          >
            <FontAwesomeIcon icon={faEnvelope} />
          </button>
        )}

        {userRole === "producer" || userRole === "director" ? (
          <Link to="/submission">
            <button className="sidebar-button">
              <FontAwesomeIcon icon={faBullhorn} />
            </button>
          </Link>
        ) : null}
      </div>
      <div className="sidebar-bottom">
        <button className="sidebar-button" onClick={handleClickProfile}>
          <FontAwesomeIcon icon={faUser} />
        </button>
        <Link to="/setting">
          <button className="sidebar-button">
            <FontAwesomeIcon icon={faCog} />
          </button>
        </Link>
        <button
          className="sidebar-button"
          onClick={() => setLogoutDialogOpen(true)}
        >
          <FontAwesomeIcon icon={faSignOutAlt} />
        </button>
      </div>
      <Dialog
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            minWidth: { xs: "280px", sm: "360px" },
            border: "1px solid rgba(229, 68, 71, 0.18)",
            boxShadow: "0 16px 40px rgba(110, 5, 6, 0.18)",
          },
        }}
      >
        <DialogTitle
          sx={{
            color: "#6e0506",
            fontWeight: 700,
            pb: 1,
          }}
        >
          Confirm Logout
        </DialogTitle>
        <DialogContent sx={{ pb: 1 }}>
          <DialogContentText sx={{ color: "#5f5f5f" }}>
            Are you sure you want to log out? You will need to sign in again to
            continue.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
          <Button
            onClick={() => setLogoutDialogOpen(false)}
            variant="outlined"
            sx={{
              color: "#6e0506",
              borderColor: "rgba(110, 5, 6, 0.35)",
              "&:hover": {
                borderColor: "#6e0506",
                backgroundColor: "#fff5f5",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleLogOut}
            variant="contained"
            sx={{
              backgroundColor: "#6e0506",
              "&:hover": {
                backgroundColor: "#8a0b0c",
              },
            }}
          >
            Log Out
          </Button>
        </DialogActions>
      </Dialog>
    </div>

    // <div className="sidebar">
    // <div className="sidebar-top">
    //   <div className="sidebar-icon">
    //     <FontAwesomeIcon icon={faEnvelope} />
    //   </div>
    //   <div className="sidebar-icon">
    //     <FontAwesomeIcon icon={faBullhorn} />
    //   </div>
    // </div>
    // <div className="sidebar-bottom">
    //   <div className="sidebar-icon">
    //     <FontAwesomeIcon icon={faUser} onClick={handleClickProfile} />
    //   </div>
    //   <Link to="/setting">
    //     <div className="sidebar-icon">
    //       <FontAwesomeIcon icon={faCog} />
    //     </div>
    //   </Link>
    //   <div className="sidebar-icon">
    //     <FontAwesomeIcon icon={faSignOutAlt} onClick={handleLogOut} />
    //   </div>
    // </div>
    // </div>
  );
};

export default Sidebar;
